import React, { Fragment, useMemo } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';
import groupByRows from 'lodash/groupBy';

const TableBodyRowsGroupBy = ({ id, columns, rows, groupBy, groupByRender, showSetting, orderGroupBy }) => {
  const newRows = useMemo(() => {
    return groupByRows(rows, groupBy);
  }, [rows]);
  const element = document.getElementById(`thead-${id}`);
  const height = element?.offsetHeight - 1 || 0;
  return (
    <TableBody key={`table-body-rows-${id}`}>
      {Object.keys(newRows)
        .sort(orderGroupBy === 'asc' ? undefined : (a, b) => (a < b ? 1 : -1))
        .map((key, index) => (
          <Fragment key={`fragment-table-body-row-group-by-${id}-${key}-${index}`}>
            <TableRow>
              <TableCell
                colSpan={columns.length}
                className='font-bold bg-muted p-0 sticky left-4 z-10'
                style={{ top: `calc(${showSetting ? '3.4rem' : '-1px'} + ${height}px)` }}
              >
                {groupByRender ? (
                  groupByRender(key, { rows: newRows[key] })
                ) : (
                  <Typography variant='subtitle1' component='span' className='sticky left-4'>
                    {key}
                  </Typography>
                )}
              </TableCell>
            </TableRow>
            {newRows[key].map((row, index) => (
              <TableRow key={`table-body-row-${id}-${row._id}-${index}`}>
                {columns.map((column) => (
                  <TableCell
                    key={`table-body-row-cell-${id}-${column.key}-${row._id}-${index}`}
                    align={column.align ? column.align : 'left'}
                    className={column.className ?? ''}
                    style={column.stickyLeft != null ? { left: column.stickyLeft } : undefined}
                  >
                    {column.key === 'index' ? index + 1 : row[column.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </Fragment>
        ))}
    </TableBody>
  );
};

export default TableBodyRowsGroupBy;
